import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";
import {ManagePartnersService} from "./manage-partners.service";
import {handleErrors} from "../misc/handle-errors.decorator";

export interface DisplayRegistrationLinkDialogModel {
  partnerId: string;
  registrationLink: string;
}

@Component({
  templateUrl: "./dialog-partner-display-registration-link.template.pug",
  providers: [
    ManagePartnersService,
  ],
})
export class DisplayRegistrationLinkDialogComponent
  extends DialogComponent<DisplayRegistrationLinkDialogModel, any> implements DisplayRegistrationLinkDialogModel {
  public partnerId: string;
  public error: Error;
  public registrationLink: string;
  public emailSentMessage: boolean = false;
  public disableButtons: boolean = false;

  static showDisplayRegistrationLinkDialogModal(
    dialogService: DialogService,
    inputs: DisplayRegistrationLinkDialogModel,
  ): Observable<any> {
    return dialogService.addDialog(
      DisplayRegistrationLinkDialogComponent,
      inputs,
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );
  }

  closeDialog(): void {
    this.result = {};
    this.close();
  }

  @handleErrors()
  async sendWelcomeEmail(): Promise<void> {
    this.disableButtons = true;
    this.emailSentMessage = await this.managePartnersService.sendWelcomeEmail(this.partnerId);
    this.disableButtons = false;
  }

  constructor(
    public dialogService: DialogService,
    private managePartnersService: ManagePartnersService,
  ) {
    super(dialogService);
  }
}
